import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { Form, Button, Card, } from 'react-bootstrap';
import useComponentState from '../../utils/useComponentState';
import styles from './AddProductCategory.module.scss';
import { toast } from 'react-toastify';
import { addProductCategory } from '../../api/Products';
import {
    INITIAL_STATE,
    TOAST_MESSAGES,
    PRODUCT_CATEGORY_FORM_FIELDS as FORM_FIELDS,
    STATUS_OPTIONS,
    validateForm,
} from './AddProductCategoryConstants';
import { PageHeader } from '../../components';



const AddProductCategory = (props) => {
    const [state, setState] = useComponentState(INITIAL_STATE);

    const handleInputChange = useCallback((fieldName, value) => {
        setState((prev) => ({
            ...prev,
            [fieldName]: value,
            error: '',
        }));
    }, [setState]);

    const handleStatusChange = (e) => {
        handleInputChange('status', e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Run JS validation
        const validationErrors = validateForm(state);
        if (Object.keys(validationErrors).length > 0) {
            setState(prevState => ({
                ...prevState,
                fieldErrors: validationErrors
            }));
            e.stopPropagation();
            return;
        }

        // Clear errors and proceed
        setState(prevState => ({
            ...prevState,
            fieldErrors: {}
        }));

        setState((prev) => ({
            ...prev,
            loading: true,
            error: '',
        }));

        try {
            const payload = {
                category: state.categoryName,
                displayOrder: parseInt(state.displayOrder),
                status: state.status,
                bannerImg1: state.bannerImage1Large,
                bannerImg2: state.bannerImage2Medium || null,
                bannerImg3: state.bannerImage3Small || null,
                displayTitle: state.displayTitle || null,
                subTitle: state.subTitle || null,
            };

            const token = props.auth.auth.token;

            await addProductCategory(payload, token);
            toast.success(TOAST_MESSAGES.success);

            setState(INITIAL_STATE);

            // Reset form and redirect if callback provided
            if (props.onSuccess) {
                props.onSuccess();
            }
        } catch (error) {
            toast.error(TOAST_MESSAGES.error);
            setState((prev) => ({
                ...prev,
                error: TOAST_MESSAGES.error,
                loading: false,
            }));
        }
    };

    const handleCancel = () => {
        setState(INITIAL_STATE);
        if (props.onCancel) {
            props.onCancel();
        }
    };



    return (
        <div className={styles.root_div}>
            <PageHeader text="Add Product Category" />

            <Card className={styles.formCard}>
                <Card.Body>

                    <Form onSubmit={handleSubmit} noValidate>
                        {FORM_FIELDS.map(({ name, label, type, placeholder, required, validationMessage }) => {
                            // Handle select fields separately
                            if (type === 'select') {
                                return (
                                    <div className={styles.formRow} key={name}>
                                        <div className={styles.labelCol}>
                                            <Form.Label>
                                                {label} {required && <span className={styles.required}>*</span>}
                                            </Form.Label>
                                        </div>
                                        <div className={styles.fieldCol}>
                                            <Form.Control
                                                as="select"
                                                className='form-select'
                                                value={state[name]}
                                                onChange={handleStatusChange}
                                                isInvalid={!!state.fieldErrors[name]}
                                            >
                                                <option value="">Select a status</option>
                                                {STATUS_OPTIONS.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                            {state.fieldErrors[name] && (
                                                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                    {state.fieldErrors[name]}
                                                </Form.Control.Feedback>
                                            )}
                                        </div>
                                    </div>
                                );
                            }

                            // Handle text/number fields
                            return (
                                <div className={styles.formRow} key={name}>
                                    <div className={styles.labelCol}>
                                        <Form.Label>
                                            {label} {required && <span className={styles.required}>*</span>}
                                        </Form.Label>
                                    </div>
                                    <div className={styles.fieldCol}>
                                        <Form.Control
                                            type={type}
                                            placeholder={placeholder}
                                            value={state[name]}
                                            onChange={(e) => handleInputChange(name, e.target.value)}
                                            isInvalid={!!state.fieldErrors[name]}
                                        />
                                        {state.fieldErrors[name] && (
                                            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                                {state.fieldErrors[name]}
                                            </Form.Control.Feedback>
                                        )}
                                    </div>
                                </div>
                            );
                        })}

                        <div className={styles.buttonGroup}>
                            <Button
                                variant="secondary"
                                onClick={handleCancel}
                                disabled={state.loading}
                            >
                                Cancel
                            </Button>

                            <Button
                                variant="primary"
                                type="submit"
                                disabled={state.loading}
                            >
                                {state.loading ? 'Adding...' : 'Add Category'}
                            </Button>
                        </div>

                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
};

export default connect(mapStateToProps)(AddProductCategory);
